import Maybe from 'true-myth/maybe';

import type { FeatureFlagService } from './feature-flag-service';
import type { initialize, LDClient, LDLogger } from 'launchdarkly-js-client-sdk';

export type LaunchDarklyFeatureFlagServiceDependencies = {
    readonly initializeLaunchDarkly: typeof initialize;
    readonly launchDarklyLogger: LDLogger;
};

export type LaunchDarklyFeatureFlagServiceOptions = {
    readonly baseUrl: string;
    readonly eventsUrl: string;
    readonly tenantId: string;
};

const clientId = '63a4309c7be8a511e1b66fc1';

export const createLaunchDarklyFeatureFlagService = (
    dependencies: LaunchDarklyFeatureFlagServiceDependencies,
    options: LaunchDarklyFeatureFlagServiceOptions,
): FeatureFlagService => {
    const { initializeLaunchDarkly, launchDarklyLogger } = dependencies;
    const { baseUrl, eventsUrl, tenantId } = options;

    let launchDarklyClient: Maybe<LDClient> = Maybe.nothing();

    let markedAsInitialized = (): void => {
        /* empty */
    };

    let initializedPromise = new Promise<void>((resolve) => {
        markedAsInitialized = resolve;
    });

    return {
        async initialize(userId) {
            const client = initializeLaunchDarkly(
                clientId,
                {
                    key: userId,
                    kind: 'user',
                    tenantId,
                },
                {
                    allAttributesPrivate: true,
                    baseUrl,
                    eventsUrl,
                    logger: launchDarklyLogger,
                    sendEventsOnlyForVariation: true,
                    streaming: false,
                },
            );

            await client.waitForInitialization();
            markedAsInitialized();

            launchDarklyClient = Maybe.just(client);
        },
        isFeatureFlagEnabled(featureFlagName) {
            return launchDarklyClient.mapOr(false, (launchDarklyClientValue) => {
                return launchDarklyClientValue.variation(featureFlagName, false);
            });
        },
        async isInitialized() {
            await initializedPromise;

            return true;
        },
    };
};
